import {Component} from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {IonicSelectableComponent} from 'ionic-selectable';

import {ValidatorProvider} from '../../providers/validator/validator';
import {AlertProvider} from '../../providers/alert/alert';
import {AuthProvider} from '../../providers/auth/auth';
import {NetworkMonitorProvider} from '../../providers/network-monitor/network-monitor';
import {EventEmitterProvider} from '../../providers/event-emitter/event-emitter';

import {RegistrationDocument} from '../../models/registrationdocument';
import {FileLikeObject, FileUploader} from 'ng2-file-upload';
import {UploadingProvider} from '../../providers/uploading/uploading';
import {TitleProvider} from '../../providers/title/title';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import {catchError, map} from 'rxjs/operators'; // if you use pipeable ops
import 'rxjs/add/observable/of';

/**
 * Generated class for the UpdateRegistrationDocumentPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration-document',
  templateUrl: 'update-registration-document.html',
})
export class UpdateRegistrationDocumentPage {

  public fileUploader: FileUploader = new FileUploader({queueLimit: 10});
  private user: any;
  public registrationDocument: RegistrationDocument;
  public documentKinds: any[];
  public scholarities: any[];
  public userFilesGet: any[];
  public titles: any[];
  private hasApprovedCertification: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private eventEmitterProvider: EventEmitterProvider,
    private uploadingprovider: UploadingProvider,
    private titleProvider: TitleProvider
  ) {
    this.hasApprovedCertification = false;
    this.registrationDocument = new RegistrationDocument();
    this.documentKinds = [
      {id: 'R', name: 'RG'},
      {id: 'C', name: 'CNH'},
      {id: 'I', name: 'Carteira de Identificação Profissional'},
      {id: 'P', name: 'Passaporte'},
      {id: 'T', name: 'Carteira Profissional'},
    ];
    this.scholarities = [
      {id: 'FI', name: 'Ensino Fundamental Incompleto'},
      {id: 'FC', name: 'Ensino Fundamental Completo'},
      {id: 'MI', name: 'Ensino Médio Incompleto'},
      {id: 'MC', name: 'Ensino Médio Completo'},
      {id: 'SI', name: 'Ensino Superior Incompleto'},
      {id: 'SC', name: 'Ensino Superior Completo'},
      {id: 'PI', name: 'Pós-graduação Incompleta'},
      {id: 'PC', name: 'Pós-graduação Completa'},
      {id: 'BI', name: 'MBA Incompleto'},
      {id: 'BC', name: 'MBA Completo'},
      {id: 'DO', name: 'Doutorado'},
    ];

    this.titleProvider.getTitles().subscribe(titles => {

      let arrTitles = [];
      titles.forEach((title) => {
        if (title.id == 18)
          arrTitles.push(title)
      })
      // console.log('arrTitles:', arrTitles)
      this.titles = arrTitles;
    })

    this.user = this.authProvider.getUser();
    if (this.user) {
      this.registrationDocument.federalCode = this.user.federalCode;
      this.registrationDocument.documentKind = this.user.documentKind;
      this.registrationDocument.documentCode = this.user.documentCode;
      this.registrationDocument.scholarity = this.user.scholarity;
    }
  }

  ionViewDidLoad() {
    this.checkFiles();
    console.log('ionViewDidLoad UpdateRegistrationDocumentPage');
  }

  getFiles(): FileLikeObject[] {
    return this.fileUploader.queue.map((fileItem) => {
      console.log('getFiles', fileItem.file);
      return fileItem.file;
    });
  }

  onBack() {
    // this.navCtrl.pop({
    //   animation: 'ios-transition'
    // });
    this.navCtrl.popToRoot();
  }

  onDocumentKindChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('document kind:', event.value);
  }

  onScholarityChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('scholarity:', event.value);
  }

  checkFiles() {
    let loader = this.loadingCtrl.create({
      content: 'Obtendo Arquivos...',
    });
    loader.present();

    this.uploadingprovider.listTitlesFiles(this.user.id).subscribe((response: any) => {
      if (response) {
        console.log('arquivos:', response);

        let arquivos: any[] = [];

        response.forEach(data => {
          if (Array.isArray(this.titles)) {
            this.titles.forEach(dt => {
              if (data.titleId == dt.id && data.titleId == 18) {
                data.titleName = dt.name;
                arquivos.push(data);
              }
            });
          }
        });

        this.userFilesGet = arquivos;

        if (this.userFilesGet.length > 0) {
          this.hasApprovedCertification = true;
        }

        console.log('listTitlesFiles response ->', this.userFilesGet);
        loader.dismiss();
      }
    }, (error: any) => {
      console.log(error);
      loader.dismiss();
      this.alertProvider.doAlert('Houve problemas ao tentar verificar se existem arquivos em anexo.', 'Atenção');
    });
  }

  doSave() {
    let files = this.getFiles();
    let titleId = '18';

    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar o documento.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationDocument.documentKind)) {
      this.alertProvider.doAlert('Forneça o tipo do documento.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationDocument.documentCode)) {
      this.alertProvider.doAlert('Forneça o número do documento.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationDocument.scholarity)) {
      this.alertProvider.doAlert('Forneça sua escolaridade.', 'Atenção');
    } else if (files.length === 0 && (!this.userFilesGet || this.userFilesGet.length === 0)) {
      this.alertProvider.doAlert('É necessário adicionar um documento de identidade para upload.', 'Atenção');
    } else {
      let that = this;
      this.alertProvider.doConfirm('Deseja salvar seu documento?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          // duration: 3000
        });
        loader.present();

        // if (files.length > 0) {
        //   files.forEach((file) => {
        //     let formData = new FormData();
        //     let userId = this.user.id;
        //     formData.append('file', file.rawFile);
        //     formData.append('titleId', titleId);
        //
        //     this.uploadingprovider.uploadFormTitleData(formData, userId).subscribe((response: any) => {
        //       if ((response) && (response.updated)) {
        //         loader.dismiss();
        //         this.checkFiles();
        //         console.log("updateTitleDocument", response);
        //       }
        //     });
        //   });
        // }
        //
        // this.updateDocument();

        this.saveTitleWithOptionalUploads(files, titleId, loader);
      });
    }
  }

  private saveTitleWithOptionalUploads(files: any[], titleId: string, loader: any) {
    const userId = this.user.id;

    if (!files || files.length === 0) {
      // No files: save right away
      this.updateDocument(loader);
      return;
    }

    // Build one upload observable per file
    const uploads: Observable<any>[] = files.map(file => {
      const formData = new FormData();
      formData.append('file', file.rawFile);
      formData.append('titleId', titleId);

      return this.uploadingprovider.uploadFormTitleData(formData, userId)
        .pipe(
          // normalize each response so forkJoin always emits
          map(res => ({ok: !!(res && res.updated), res})),
          catchError(err => Observable.of({ok: false, err}))
        );
    });

    // Wait for ALL uploads to complete
    Observable.forkJoin(uploads).subscribe(results => {
      // Optional: check if any failed
      const anyFailed = results.some(r => !r.ok);
      if (anyFailed) {
        console.warn('One or more uploads failed:', results);
        // handle accordingly (toast, retry, etc.)
      } else {
        console.log('All uploads completed:', results.map(r => r.res));
        this.checkFiles(); // if you still need this after all uploads
      }

      // Only now save the data
      this.updateDocument(loader);
    }, err => {
      console.error('Unexpected error waiting uploads:', err);
      if (loader) {
        loader.dismiss();
      }
    });
  }

  private updateDocument(loader: any): void {
    const that = this;

    that.authProvider.updateDocument(that.registrationDocument).subscribe((response: any) => {
      if ((response) && (response.updated)) {
        that.alertProvider.doAlert('Seus dados pessoais foram salvos com sucesso.', 'Informação');
        loader.dismiss();

        // Update local user data
        that.user.documentKind = that.registrationDocument.documentKind;
        that.user.documentCode = that.registrationDocument.documentCode;
        that.user.scholarity = that.registrationDocument.scholarity;

        that.authProvider.setUser(that.user);
        that.eventEmitterProvider.get('registration_updated').emit(that.user);
      } else {
        loader.dismiss();
        that.alertProvider.doAlert('Houve problemas ao tentar salvar seu documento. Tente novamente mais tarde.', 'Atenção');
      }
    }, (error: any) => {
      console.log(error);
      loader.dismiss();
      that.alertProvider.doAlert('Houve problemas ao tentar salvar seu documento. Tente novamente mais tarde.', 'Atenção');
    });
  }

  removeFile(fileId) {
    this.uploadingprovider.removeTitleFile(fileId).subscribe((response: any) => {
      if ((response) && (response.updated)) {
        this.checkFiles();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/update-registration-document/update-registration-document.ts